import type { ViewMode, Book, SortConfig, FieldVisibility } from '@/types'
import type { MouseEvent, ChangeEvent } from 'react'
import FullCardsView from './views/FullCardsView'
import CompactCardsView from './views/CompactCardsView'
import CompactListView from './views/CompactListView'
import ExtendedListView from './views/ExtendedListView'

interface BookWithProfile extends Book {
    profiles?: {
        full_name?: string | null
    }
}

interface BookListGridProps {
    viewMode: ViewMode
    books: BookWithProfile[]
    selectedIds: Set<string>
    toggleBookSelection: (e: MouseEvent | ChangeEvent, bookId: string) => void
    onBookClick: (book: BookWithProfile) => void
    initiateDelete: (e: MouseEvent, bookId: string) => void
    isBiblioverso: boolean
    isSharedView: boolean
    deletingId: string | null
    sharedSettings?: string[] | null
    allFilteredSelected: boolean
    deselectAll: () => void
    selectAllFiltered: () => void
    sortConfig: SortConfig
    handleSort: (key: string) => void
    visibility: FieldVisibility
    toggleField: (field: keyof FieldVisibility) => void
    resetToDefaults: () => void
    allowedFields: string[] | null
}

export default function BookListGrid({ viewMode, ...props }: Readonly<BookListGridProps>) {
    switch (viewMode) {
        case 'full-cards':
            return <FullCardsView {...props} />
        case 'compact-cards':
            return <CompactCardsView {...props} />
        case 'compact-list':
            return <CompactListView {...props} />
        case 'extended-list':
            return <ExtendedListView {...props} />
        default:
            return null
    }
}
